const patientsOrders = {
  PatientOrders: "{{ patientTerm }} orders",
  Paid: "Paid",
  Returned: "Returned",
  by: "by",
  ReadyForShipment: "Ready for shipment",
  PartiallyShipped: "Partially shipped",
  EmptyOrders: "You don't have any {{ patientTerm }} orders yet",
  EmptyOrdersBothFilter: "There are no orders for {{ patientName }} in {{ year }}",
  EmptyOrdersPatientFilter: "There are no orders for {{ patientName }} yet",
  EmptyOrdersYearFilter: "There are no orders in {{ year }}",
  FollowUpWithPatients:
    "{{action}} a new {{treatmentPlanTerm}} or send a reminder to your {{ patientTermPlural }} to keep them on track",
  CreateNewPrescription: "Create new {{ treatmentPlanTerm }}",
  BuildPlan: "Build plan",
  AllDates: "All dates",
  AllPatients: "All {{ patientTerm }}",
  ThereAreNoResults: "There are no results",
  QuicklyFilter: "Quickly filter...",
  withSourcePlatform: {
    EmptyOrders: "You don't have any {{ patientTerm }} {{ sourcePlatform }} orders yet",
    EmptyOrdersBothFilter:
      "There are no {{sourcePlatform}} orders for {{ patientName }} in {{ year }}",
    EmptyOrdersPatientFilter: "There are no {{ sourcePlatform }} orders for {{ patientName }} yet",
    EmptyOrdersYearFilter: "There are no {{ sourcePlatform }} orders in {{ year }}",
  },
  ViewAllRecommendations: "View all {{ treatmentPlanTermPlural }}",
} as const;

export { patientsOrders };
